"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;
var _interfaces = require("./interfaces");
Object.keys(_interfaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interfaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _interfaces[key];
    }
  });
});
const primaryFont = {
  family: '"Amazon Ember", Helvetica, sans-serif',
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
  },
  size: {
    T600: {
      xl: {
        fontSize: '2.5rem',
        lineHeight: 1.3
      },
      l: {
        fontSize: '2.5rem',
        lineHeight: 1.3
      },
      m: {
        fontSize: '2rem',
        lineHeight: 1.375
      },
      s: {
        fontSize: '2rem',
        lineHeight: 1.35714
      }
    },
    T500: {
      xl: {
        fontSize: '2rem',
        lineHeight: 1.375
      },
      l: {
        fontSize: '2rem',
        lineHeight: 1.42857
      },
      m: {
        fontSize: '1.75rem',
        lineHeight: 1.46154
      },
      s: {
        fontSize: '1.75rem',
        lineHeight: 1.45455
      }
    },
    T400: {
      xl: {
        fontSize: '1.5rem',
        lineHeight: 1.5
      },
      l: {
        fontSize: '1.5rem',
        lineHeight: 1.5
      },
      m: {
        fontSize: '1.375rem',
        lineHeight: 1.5
      },
      s: {
        fontSize: '1.375rem',
        lineHeight: 1.5
      }
    },
    T300: {
      xl: {
        fontSize: '1.25rem',
        lineHeight: 1.55556
      },
      l: {
        fontSize: '1.25rem',
        lineHeight: 1.55556
      },
      m: {
        fontSize: '1.125rem',
        lineHeight: 1.5
      },
      s: {
        fontSize: '1.125rem',
        lineHeight: 1.5
      }
    },
    T200: {
      xl: {
        fontSize: '1rem',
        lineHeight: 1.5
      },
      l: {
        fontSize: '1rem',
        lineHeight: 1.5
      },
      m: {
        fontSize: '1rem',
        lineHeight: 1.5
      },
      s: {
        fontSize: '1rem',
        lineHeight: 1.5
      }
    },
    T100: {
      xl: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      },
      l: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      },
      m: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      },
      s: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      }
    },
    T50: {
      xl: {
        fontSize: '0.75rem',
        lineHeight: 1.57143
      },
      l: {
        fontSize: '0.75rem',
        lineHeight: 1.57143
      },
      m: {
        fontSize: '0.75rem',
        lineHeight: 1.57143
      },
      s: {
        fontSize: '0.75rem',
        lineHeight: 1.57143
      }
    }
  }
};
const pxtThemeColors = {
  primary05: '#ebf5fd',
  primary10: '#d7ebfb',
  primary20: '#afd7f7',
  primary30: '#87c2f4',
  primary40: '#5faef0',
  primary50: '#379aec',
  primary60: '#0077d9',
  primary70: '#1768c9',
  primary80: '#1659a9',
  primary90: '#123b74',
  neutral0: '#ffffff',
  neutral05: '#f1f4f7',
  neutral10: '#e8eaee',
  neutral20: '#d1d5da',
  neutral30: '#b9c0c8',
  neutral40: '#a2abb5',
  neutral50: '#8b96a3',
  neutral60: '#737e8b',
  neutral70: '#56616c',
  neutral80: '#394451',
  neutral90: '#232f3e',
  neutral100: '#161e2d',
  green05: '#ebf9f6',
  green10: '#d7f3ed',
  green20: '#afe7db',
  green30: '#86dac9',
  green40: '#5eceb7',
  green50: '#00a890',
  green60: '#008574',
  green70: '#23756b',
  green80: '#195f57',
  green90: '#104643',
  yellow05: '#fff9e6',
  yellow10: '#fff3cc',
  yellow20: '#ffe799',
  yellow30: '#ffdc66',
  yellow40: '#ffd033',
  yellow50: '#ffc400',
  yellow60: '#ca8700',
  yellow70: '#b27400',
  yellow80: '#8E5D00',
  yellow90: '#684500',
  red05: '#fef0ef',
  red10: '#fde1df',
  red20: '#fbc3bf',
  red30: '#f8a49e',
  red40: '#f6867e',
  red50: '#f4685e',
  red60: '#da3733',
  red70: '#bb2929',
  red80: '#9a1818',
  red90: '#710400',
  pink05: '#faf2f7',
  pink10: '#f3deeb',
  pink20: '#e8bdd7',
  pink30: '#dd9cc4',
  pink40: '#d27bb0',
  pink50: '#cf6ba0',
  pink60: '#ba3385',
  pink70: '#a90067',
  pink80: '#8b065b',
  pink90: '#6e0c4f',
  purple05: '#f9f1fd',
  purple10: '#f2e4fb',
  purple20: '#e5c8f7',
  purple30: '#d9adf2',
  purple40: '#cc91ee',
  purple50: '#bf76ea',
  purple60: '#a249e0',
  purple70: '#8b46c6',
  purple80: '#7037a3',
  purple90: '#51267f',
  'neutral100-alpha10': 'rgba(35, 47, 62, 0.1)',
  'neutral100-alpha30': 'rgba(35, 47, 62, 0.3)',
  'neutral100-alpha50': 'rgba(35, 47, 62, 0.5)',
  'neutral100-alpha70': 'rgba(35, 47, 62, 0.7)',
  'neutral100-alpha90': 'rgba(35, 47, 62, 0.9)',
  'neutral0-alpha10': 'rgba(255, 255, 255, 0.1)',
  'neutral0-alpha30': 'rgba(255, 255, 255, 0.3)',
  'neutral0-alpha50': 'rgba(255, 255, 255, 0.5)',
  'neutral0-alpha70': 'rgba(255, 255, 255, 0.7)',
  'neutral0-alpha90': 'rgba(255, 255, 255, 0.9)',
  'primary60-alpha10': 'rgba(0, 119, 217, 0.1)',
  'primary60-alpha30': 'rgba(0, 119, 217, 0.3)',
  'primary60-alpha50': 'rgba(0, 119, 217, 0.5)',
  'primary60-alpha70': 'rgba(0, 119, 217, 0.7)',
  'primary60-alpha90': 'rgba(0, 119, 217, 0.9)',
  'green60-alpha10': 'rgba(0, 133, 116, 0.1)',
  'green60-alpha30': 'rgba(0, 133, 116, 0.3)',
  'green60-alpha50': 'rgba(0, 133, 116, 0.5)',
  'green60-alpha70': 'rgba(0, 133, 116, 0.7)',
  'green60-alpha90': 'rgba(0, 133, 116, 0.9)',
  'yellow50-alpha10': 'rgba(255, 196, 0, 0.1)',
  'yellow50-alpha30': 'rgba(255, 196, 0, 0.3)',
  'yellow50-alpha50': 'rgba(255, 196, 0, 0.5)',
  'yellow50-alpha70': 'rgba(255, 196, 0, 0.7)',
  'yellow50-alpha90': 'rgba(255, 196, 0, 0.9)',
  'red60-alpha10': 'rgba(218, 55, 51, 0.1)',
  'red60-alpha30': 'rgba(218, 55, 51, 0.3)',
  'red60-alpha50': 'rgba(218, 55, 51, 0.5)',
  'red60-alpha70': 'rgba(218, 55, 51, 0.7)',
  'red60-alpha90': 'rgba(218, 55, 51, 0.9)',
  'pink60-alpha10': 'rgba(186, 51, 133, 0.1)',
  'pink60-alpha30': 'rgba(186, 51, 133, 0.3)',
  'pink60-alpha50': 'rgba(186, 51, 133, 0.5)',
  'pink60-alpha70': 'rgba(186, 51, 133, 0.7)',
  'pink60-alpha90': 'rgba(186, 51, 133, 0.9)',
  'purple60-alpha10': 'rgba(162, 73, 224, 0.1)',
  'purple60-alpha30': 'rgba(162, 73, 224, 0.3)',
  'purple60-alpha50': 'rgba(162, 73, 224, 0.5)',
  'purple60-alpha70': 'rgba(162, 73, 224, 0.7)',
  'purple60-alpha90': 'rgba(162, 73, 224, 0.9)'
};
const radius = {
  R100: 4,
  R200: 6,
  R300: 8,
  R400: 16,
  R500: 20,
  R600: 22,
  R700: 30,
  R800: 40,
  R900: 80,
  R1000: 100
};
const defaultTheme = {
  color: {
    ...pxtThemeColors
  },
  space: {
    S100: 4,
    S200: 8,
    S250: 12,
    S300: 16,
    S400: 24,
    S500: 32,
    S600: 48,
    S700: 64
  },
  breakpoint: {
    s: {
      max: 600
    },
    m: {
      min: 601,
      max: 970
    },
    l: {
      min: 971,
      max: 1280
    },
    xl: {
      min: 1281
    }
  },
  // we should only load webfonts if they are not local
  // https://developers.google.com/web/fundamentals/performance/optimizing-content-efficiency/webfont-optimization?hl=en#defining-font-family-with-font-face
  font: {
    primary: primaryFont,
    monospace: {
      ...primaryFont,
      family: '"Amazon Ember Mono", Consolas, Monaco, monospace'
    }
  },
  zIndex: {
    highest: 1000,
    modal: 900,
    flyout: 800,
    header: 700,
    stickyContent: 650,
    sideMenu: 600,
    dropdown: 500,
    popover: 400,
    alert: 300
  },
  radius,
  constants: {
    maxWidth: 1440,
    pageHorizontalPadding: '2.5vw',
    headerHeight: 64
  }
};
var _default = exports.default = defaultTheme;